import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

// Captures tokens from URL into sessionStorage before Angular starts.
// URL cleaning is handled by UrlTokenService after Angular boots.
// Only structurally valid JWTs (3 dot-separated parts) are stored.
// JSON.stringify is intentional: StorageService.getSessionStorage() deserializes with JSON.parse().
(function captureUrlTokens() {
  const isJwt = (v: string) => v.split('.').length === 3;

  const hash = window.location.hash;
  const queryString = hash.includes('?') ? hash.split('?')[1] : '';
  const params = new URLSearchParams(queryString);

  const accessToken     = params.get('accessToken');
  const token           = params.get('token');
  const refreshToken    = params.get('refreshToken');

  if (accessToken && isJwt(accessToken))
    sessionStorage.setItem('urlAccessToken', JSON.stringify(accessToken));
  if (token)
    sessionStorage.setItem('urlLegacyToken', JSON.stringify(token));
  if (refreshToken && isJwt(refreshToken))
    sessionStorage.setItem('urlRefreshToken', JSON.stringify(refreshToken));
})();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
